import { useState } from "react";

const faqs = [
  {
    q: "可可漫画网可以免费看漫画吗？",
    a: "可以。可可漫画网聚合萌系、少女与甜宠题材的漫画作品，大部分内容都可以免费在线阅读，方便你先试读再决定是否收藏追更。",
  },
  {
    q: "漫画每天什么时候更新？",
    a: "本站每天都会更新连载作品，通常在中午 12:00 左右集中上线当日新话，并在「每日更新」栏目集中展示，方便你第一时间查看。",
  },
  {
    q: "追更的漫画更新后如何提醒我？",
    a: "你只需收藏喜欢的作品，系统会自动记录更新进度，新话上线后会在追更列表和更新提醒中高亮提示，避免错过更新。",
  },
  {
    q: "收藏的作品进度会同步吗？",
    a: "会的。收藏记录和阅读进度会自动同步，方便你在不同设备上继续追更，续读、回看章节都很顺畅。",
  },
  {
    q: "有哪些题材可以按需筛选？",
    a: "目前提供萌系、少女、甜宠、治愈、校园恋爱、轻松搞笑、奇幻穿越、日常轻百等题材分类，也可以用关键词搜索快速定位作品。",
  },
  {
    q: "如何联系网站反馈问题？",
    a: "你可以通过页面底部或「订阅更新」栏目留下的联系方式，把意见建议或想看的新题材告诉我们，我们会认真阅读每一条反馈。",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="text-center">
        <p className="text-sm font-semibold text-primary-600">常见问题</p>
        <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-3xl">你可能想问</h2>
        <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
          关于找漫、追更、更新提醒的常见问题，一次说清楚。
        </p>
      </div>

      <div className="mt-8 divide-y divide-background-200 rounded-lg bg-background-100/60 px-4 md:px-6">
        {faqs.map((item, i) => {
          const open = openIndex === i;
          return (
            <div key={item.q}>
              <h3>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 py-4 text-left"
                >
                  <span className="text-sm font-medium text-foreground-950 md:text-base">{item.q}</span>
                  <i
                    className={`shrink-0 text-lg text-primary-600 transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`}
                    aria-hidden="true"
                  ></i>
                </button>
              </h3>
              {open && (
                <p className="pb-5 pl-0 text-sm leading-relaxed text-foreground-600">{item.a}</p>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}